import { updateMyData, getMyData, login, updateBgColor, updateTextColor } from '../../api'
export default ({
    state: {
        myContent: "",
        colorText: '',
        colorBg: ''
    },
    mutations: {
        SET_MY_DATA(state, data) {
            state.myContent = data
        },
        SET_BG_COLOR(state, data) {
            state.colorBg = data || '#000000'
        },
        SET_TEXT_COLOR(state, data) {
            state.colorText = data || '#FFFFFF'
        }
    },
    actions: {
        async updateMyData(store, { content, fb, insta, contentDesc, url }) {
            await updateMyData(content, fb, insta, contentDesc, url)

        },
        async getMyData({ commit }) {

            const result = await getMyData()
            commit('SET_MY_DATA', result)
            commit('SET_BG_COLOR', result.bgColor)
            commit('SET_TEXT_COLOR', result.textColor)
        },
        async login(store, { mail, pwd }) {
            try {
                await login(mail, pwd)

            } catch (e) {
                console.log(e)
            }
        },
        async updateBgColor({ commit }, color) {
            await updateBgColor(color)
            commit('SET_BG_COLOR', color)
            alert('Bg color updated')
        },
        async updateTextColor({ commit }, color) {
            await updateTextColor(color)
            commit('SET_TEXT_COLOR', color)
            alert('Text color updated')
        }
    },
    getters: {
        getMyDataContent: state => state.myContent,
        getBgColor: state => state.colorBg,
        getTextColor: state => state.colorText
    }
})